export const HYDRA_TEST_VARIABLE = 'htv'; // currently not a real test; used for documentation and unit testing
export const HYDRA_COLA = 'cola'; // [C]reate [O]ut-of-Stock [L]ink on "[A]dd to Cart" Button
export const HYDRA_STICKY_ADD_TO_CART = 'stack'; // [ST]icky [A]dd to [C]art with an extra [K]
export const HYDRA_CHECKOUT_PRIVATE_LABEL_CREDIT_CARD = 'cplc'; // [C]heckout [P]rivate [L]abel Credit [C]ard
export const HYDRA_CHECKOUT_NEXT_DAY_SHIPPING = 'cnds'; // [C]heckout [N]ext [D]ay [S]hipping
export const HYDRA_FILTER_KEYWORD = 'fkw2'; // [F]ilter [K]ey[W]ord
export const HYDRA_ECO_SHIPPING = 'ecs'; // [EC]o [S]hipping
export const HYDRA_SEARCH_QUICK_SHOP = 'sqs'; // [S]earch [Q]uick [S]hop
export const HYDRA_BELOW_ADD_TO_CART_SLOT = 'batc'; // [B]elow [A]dd [T]o [C]art Slot
export const HYDRA_OUTFITS_ON_WEB = 'out'; // [OUT]fits
export const HYDRA_CC_VERIFY = 'crv'; // [Cr]edit Card [V]erify
export const HYDRA_AMAZONPAY_COUPONS = 'apc'; // [A]mazon [P]ay [C]oupons
export const HYDRA_VIRTUAL_SANTA = 'vrs'; // [V]i[r]tual [S]anta
export const HYDRA_SPLIT_SHIPMENTS = 'ssp'; // [S]plit [S]hi[p]ments
export const HYDRA_SUBSEQUENT_EXCHANGE_BUTTON = 'ssxb'; // [S]ub[s]equent E[x]change [B]utton
export const HYDRA_CHECKOUT_PAYMENT_FORM = 'cpfo'; // [C]heckout [P]ayment [Fo]rm
export const HYDRA_CHECKOUT_ADDRESS_FORM = 'cafo'; // [C]heckout [A]ddress [Fo]rm
export const HYDRA_CHECKOUT_RADIO_PAYMENTS = 'crp'; // [C]heckout [R]adio [P]ayments
export const HYDRA_POST_PURCHASE_UPSELL = 'ppus'; // [P]ost [P]urchase [U]p [S]ell
export const HYDRA_BEST_GUESS = 'gbfy'; // [G]uess [B]est [F]or [Y]ou
export const HYDRA_WEAR_IT_WITH_UP = 'wiwu'; // [W]ear [I]t [W]ith [U]p
export const HYDRA_VIP_ENROLLMENT_AT_CHECKOUT = 'vec'; // [V]ip [E]nrollment at [C]heckout
export const HYDRA_REVIEW_SUMMARY_ON_PDP = 'rsop'; // [R]eview [S]ummary [O]n [P]roduct Detail Page
export const HYDRA_KIDS_SIZE_BUY_BOX = 'ksbb'; // [K]ids [S]ize [B]uy [B]ox (parodies "Kids Size Break Merge", the old ksbm hydra test)
export const HYDRA_ZANIMANIACS_EMPTY_REVIEW = 'aer'; // [A]nimated [Empty] [R]eviews
export const HYDRA_ZANIMANIACS_REVIEW_CONFIRMATION = 'arsc'; // [Z]animaniacs [R]eview [C]onfirmation
export const HYDRA_INFLUENCER_SHOPPABLE_POSTS = 'isp'; // [I]nfluencer [S]hoppable [P]osts
export const HYDRA_INFLUENCER_STOREFRONT = 'ist'; // [I]nfluencer [St]orefront
export const HYDRA_ACCORDION_SIZE_CHART = 'asc'; // [A]ccordion [S]ize [C]hart
export const HYDRA_SEARCH_PRODUCT_HOVER = 'sph'; // [S]earch [P]roduct [H]over
export const HYDRA_AKITA_V2 = 'hakt'; // [H]ydra [AKT]i[T]a V2
export const HYDRA_VIP_BANNER = 'pdv'; // [PD]P [V]IP Banner
export const HYDRA_MANDATORY_RETURN_REASONS = 'mrrs'; // [M]andatory [R]eturn [R]eason[S]
export const HYDRA_CART_UPSELL = 'CUP2'; // [C]art [UP]sell [2]
